
import { useState, useEffect } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import { RiErrorWarningLine } from "react-icons/ri";


function CustomModal({
  showModal,
  onClose,
  title,
  message,
  iconType,
  showActions = false,
  onConfirm,
  confirmText = 'OK',
  cancelText = 'Cancel',
  autoRedirect = false,
  redirectUrl = null,
}) {
  // Debug logging whenever props change
  useEffect(() => {
    console.log('CustomModal props:', {
      showModal,
      autoRedirect,
      redirectUrl,
      redirectUrlType: typeof redirectUrl,
      redirectUrlValue: redirectUrl
    });
  }, [showModal, autoRedirect, redirectUrl]);

  useEffect(() => {
    if (showModal && autoRedirect) {
      if (redirectUrl) {
        console.log('✅ Auto-redirect enabled. Redirecting to:', redirectUrl);
        // Auto redirect after 1 second
        const timer = setTimeout(() => {
          console.log('🚀 Executing redirect now to:', redirectUrl);
          window.location.href = redirectUrl;
        }, 1000);

        return () => {
          console.log('⏹️ Cleaning up redirect timer');
          clearTimeout(timer);
        };
      } else {
        console.error('❌ Auto-redirect enabled but redirectUrl is undefined or empty!');
        console.log('REACT_APP_FRONTEND_URL from env:', process.env.REACT_APP_FRONTEND_URL);
      }
    }
  }, [showModal, autoRedirect, redirectUrl]);

  const handleClose = () => {
    if (autoRedirect && redirectUrl) {
      window.location.href = redirectUrl;
    } else {
      onClose();
    }
  };

  return (
    <>
      <Modal className='custom-modal'
        show={showModal}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton/>
        <Modal.Body>
          <div className="">
            <div className="icon mb-2">
              {iconType === 'warning' ? (
                <RiErrorWarningLine size={96} />
              ) : (
                <IoMdCheckmarkCircleOutline size={96} />
              )}
            </div>
            <h2>{title || 'Thank you!'}</h2>
            <p>{message || 'Your details have been saved successfully.'}</p>
            {showActions && (
              <div className="d-flex justify-content-end gap-2 mt-3">
                <Button variant="outline-secondary" onClick={handleClose}>{cancelText}</Button>
                <Button variant="danger" onClick={onConfirm}>{confirmText}</Button>
              </div>
            )}
          </div>
        </Modal.Body>
        </Modal>
    </>
  );
}

export default CustomModal;